import { Injectable } from '@angular/core';
import { CanMatch, Route, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthState } from '../store/app/app.states';
import { filter, map, Observable, of, take } from 'rxjs';
import { getUserPermissions } from '../store/auth-state/auth.selectors';

@Injectable({ providedIn: 'root' })
export class PermissionGuard implements CanMatch {
  constructor(
    private readonly router: Router,
    private readonly store: Store<AuthState>
  ) {}

 canMatch(route: Route): Observable<boolean | UrlTree> {
  const required = route.data?.['permission'] as string[];

  // No permission required
  if (!required?.length) {
    return of(true);
  }

  return this.store.select(getUserPermissions).pipe(
    take(1),
    map((permissions) => {

      //  USER NOT LOGGED IN YET → DO NOT BLOCK
      if (permissions === undefined || permissions === null) {
        return true;
      }

      // Logged in but no permissions
      if (!Array.isArray(permissions) || permissions.length === 0) {
        return this.router.parseUrl('/no-access');
      }

      const hasPermission = permissions.some(p =>
        required.includes(p)
      );

      return hasPermission
        ? true
        : this.router.parseUrl('/forbidden');
    })
  );
}



}
